// extracted by mini-css-extract-plugin
export default {"component":"ModalShell_component__5ggIs","modal_card":"ModalShell_modal_card__7loYj","dark":"ModalShell_dark__rITQ4"};